import ComposedUrl from './composedUrl';

/**
 * @param {String} emailTool
 * @param {String} url
 * @return {String}
 * */
const composeNewUrl = (emailTool, url) => new ComposedUrl(emailTool, url).getNewUrl();

const formatDuration = duration => {
	let localDuration = duration;
	const hours = String(Math.floor(localDuration / 3600));

	localDuration -= hours * 3600;
	const minutes = String(Math.floor(localDuration / 60));

	localDuration -= minutes * 60;
	const seconds = String(localDuration);

	const units = [];

	if (hours) {
		units.push(hours.padStart(2, '0'));
	}

	units.push(minutes.padStart(2, '0'));
	units.push(seconds.padStart(2, '0'));

	return units.join(':');
};

export {
	composeNewUrl,
	formatDuration
};
